import React, { Fragment } from 'react'
import { Card, CardBody, Col, Container, Row, Button,Input } from 'reactstrap';
import { TableStriped } from '../../components/tables/TableStriped';
import { ModalTypePrecodedText } from '../../components/typePrecodedTexts/ModalTypePrecodedText';
import { useTypePrecodedTexts } from '../../hooks/typePrecodedTexts/useTypePrecodedText';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const IndexTypePrecodedTexts = () => {
    const {
        typePrecodedTexts, method,
        name, handleInputChange, validaciones,
        toggle, modal, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete, data,
        arrayPrecod, data2, changeOrder, changeArrayPrecod,
        totalPageCount, currentPage, nextPage, previousPage, goToPage,
        handleSearchPrecod

    } = useTypePrecodedTexts();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const header = (
    <div
        className="d-flex align-items-center justify-content-between"
        style={{
        width: "100%",
        gap: "1rem",
        flexWrap: "nowrap",
        marginBottom: "10px",
        }}
    >
        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
        <Button
            className="btn btn-pill btn-air-success"
            color="secondary"
            size="sm"
            onClick={handleCreate}
            title="Agregar tipo de texto precodificado"
        >
            <span className="fa fa-plus-circle"></span>
        </Button>
        </div>

        <div style={{ flexGrow: 1, maxWidth: "400px" }}>
        <Input
            placeholder="Búsqueda..."
            className="form-control"
            onChange={handleSearchPrecod}
            style={{
            height: "35px",
            fontSize: "0.9rem",
            }}
        />
        </div>
    </div>
    );

     const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_type_precoded_text)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.id_type_precoded_text)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };




    return (
        <Fragment>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-1">
                               <div className="ribbon ribbon-clip ribbon-primary">
                                    Listado de tipos de texto precodificados
                                </div>
                                <br /><br /><br />

                                    <DataTable 
                                        value={typePrecodedTexts} 
                                        paginator
                                        rows={10}
                                        rowsPerPageOptions={[10, 20, 50]} 
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        responsiveLayout="scroll"
                                        header={header}
                                        emptyMessage={
                                            <div className="text-center">
                                                <img 
                                                    src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} 
                                                    style={{ width: "25%" }} 
                                                    alt="Sin resultados" 
                                                />
                                                <br />
                                                <p className='badge badge-light-primary mt-2' style={{fontSize: "15px"}}>
                                                    No hay coincidencias con la búsqueda.
                                                </p>
                                            </div>
                                        }
                                        >

                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="name" header="Nombre"  headerStyle={headerStyle} style={centerStyle} />
                    
                                        <Column header="Acciones" body={actions}exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                    </DataTable>
                               
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <ModalTypePrecodedText
                    {...{ modal, toggle, loading, method, name, handleInputChange, validaciones, saveCreate, saveUpdate, saveDelete, data, data2, changeOrder, arrayPrecod, changeArrayPrecod }}
                />
            </div>
        </Fragment>
    )
}
